<template>
    <div class="maxCollapse">
        <position-list :pageLimit="pageLimit" v-if="order == 'open'" :providerId="providerId" :providerName="providerName" :order="order"></position-list>
        <!-- <order-list :pageLimit="pageLimit" v-show="order == 'pending'" :order="order"></order-list>
        <trade-logs :pageLimit="pageLimit" v-if="order == 'transition-history'" :order="order"></trade-logs> -->
        <trade-history :pageLimit="pageLimit" v-if="order == 'history'" :providerId="providerId" :providerName="providerName" :order="order"></trade-history>
    </div>
</template>
<script>
    import positionList from './position-list'
    // import orderList from './order-list'
    import tradeHistory from './trade-history'
    // import tradeLogs from './trade-logs'
    import { commonAllmixins } from '@/plugins/commonAll'
    // import { Const } from '@/plugins/vue-provider-cache/const.mod'
    // import moment from 'moment'
export default {
    name: 'home-view',
    mixins: [commonAllmixins],
    props : ['providerId','providerName'],
    data() {
        return {
            order: 'open',
            pageLimit : 5
        }
    },
    components:{
        positionList,
        // orderList,
        tradeHistory,
        // tradeLogs
    },
    /*props:{
        pageLimit:{
            type: Number,
            default: 5
        }
    }*/
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/copy-order/order-history.vue